// extracted by mini-css-extract-plugin
export var avatar = "_p1-3";
export var avatarContainer = "_p1-2";
export var avatarSpacer = "_p1-5";
export var avatarSpacerContainer = "_p1-4";
export var avatarStackContainer = "_p1-1";
export var bubble = "_p1-0";
export var remainderBubble = "_p1-6";